module.exports = __webpack_public_path__ + "img/custom-duplicate.82225e74.svg";